import React from 'react';
import PropTypes from 'prop-types';
import FileDropzoneField from 'components/input/Dropzone/FileDropzoneField';

const ImageDropzoneField = (props) => {
    const {
        acceptedFormat,
        buttonText,
        createAction,
        dropZoneId,
        formDataKey,
        id,
        maxWidth,
        maxHeight,
        minHeight,
        minWidth,
        multiple,
    } = props;

    return (
        <FileDropzoneField
            acceptedFormat={ acceptedFormat }
            buttonText={ buttonText }
            createAction={ createAction }
            dropZoneId={ dropZoneId }
            formDataKey={ formDataKey }
            id={ id }
            maxWidth={ maxWidth }
            maxHeight={ maxHeight }
            minHeight={ minHeight }
            minWidth={ minWidth }
            multiple={ multiple }
        />
    );
};

ImageDropzoneField.propTypes = {
    acceptedFormat: PropTypes.string,
    buttonText: PropTypes.string,
    createAction: PropTypes.func.isRequired,
    dropZoneId: PropTypes.string.isRequired,
    formDataKey: PropTypes.string,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    maxHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    minHeight: PropTypes.number,
    minWidth: PropTypes.number,
    multiple: PropTypes.bool,
};

ImageDropzoneField.defaultProps = {
    acceptedFormat: 'image/png',
    formDataKey: 'image',
    maxHeight: 300,
    maxWidth: 300,
    multiple: false,
};

export default ImageDropzoneField;



// WEBPACK FOOTER //
// ./src/components/input/Dropzone/ImageDropzoneField.js